import { RouteObject } from 'react-router-dom'
import OperacoesClientesPage from '@/pages/operacoes/OperacoesClientesPage'
import PendenciasDocumentosPage from '@/pages/pendencias/PendenciasDocumentosPage'
import { SomenteBackoffice } from '../SomenteBackoffice'

/**
 * Rotas do A04 (Onda 2 — padrão de página do consultor).
 *
 * As duas páginas unificadas com abas do Figma assumem os paths que o A02 registrou com
 * as páginas antigas via `PorAba` — a substituição prevista no comentário de
 * `rotas/a02.tsx` ("as páginas do Figma chegam nas rodadas 2–4 e substituem estes
 * elementos"). O `?aba=` dos redirects antigos (`/clientes` → `?aba=clientes`,
 * `/documentos` → `?aba=documentos`) continua honrado DENTRO das páginas novas.
 *
 * INTEGRAÇÃO (coordenador, ao concatenar em `router/index.tsx`): os dois paths abaixo já
 * existem em `rotasA02`; entre rotas irmãs de mesmo path o react-router fica com a
 * registrada PRIMEIRO. Portanto `...rotasA04` precisa entrar ANTES de `...rotasA02` na
 * lista de filhos do layout — ou as duas entradas `PorAba` de `operacoes-clientes` e
 * `pendencias-documentos` saem de `rotas/a02.tsx`. Este arquivo não edita o do A02 de
 * propósito (matriz de propriedade).
 *
 * As demais telas da onda (Dashboard, Minhas Reservas, Agenda, Financeiro, Produtos e
 * Materiais, Busca com IA) não mudam de rota: os componentes existentes foram atualizados
 * no lugar.
 */
const rotasA04: RouteObject[] = [
  // 23/10: só back-office — o consultor volta ao dashboard.
  {
    path: 'operacoes-clientes',
    element: (
      <SomenteBackoffice>
        <OperacoesClientesPage />
      </SomenteBackoffice>
    ),
  },
  { path: 'pendencias-documentos', element: <PendenciasDocumentosPage /> },
]

export default rotasA04
